<template>
    <div class="container">
        <div class="validity-form-root"> 
            <h3 class="title"> {{name}} </h3>
            <div class="export-container">
                <div v-show="modalStyle == 'GROUP'">
                    <label for="export-unity">{{$t('group_of_dishes')}}:</label>
                    <div class="select-container">
                        <v-select
                            class="restrinctions-select-autocomplete"
                            :multiple="showMultiGroup"
                            :disabled="showMultiGroup && view.exportData.checkedMultGroup"
                            :options="view.exportData.groupPrat"
                            :getOptionLabel="o => `${o.CDGRUPOPRATO} | ${o.NMGRUPOPRATO}`"
                            :clearable="false" 
                            v-model="view.exportData.selectedGroupPrat"
                        ></v-select>
                        <div v-show="showMultiGroup" class="input-container">
                            <input 
                                class="allCheck"
                                type="checkbox"
                                id="scales"
                                name="scales"
                                :checked="view.exportData.checkedMultGroup"
                                @click="allMultiGroupClicked" 
                            />
                            <span>{{$t('all')}}</span>
                        </div>
                    </div>
                </div>
                <div v-show="modalStyle == 'UNITY' || modalStyle == 'GROUP'">
                    <label for="export-unity">{{$t('unit')}}:</label>
                    <div class="select-container">
                        <v-select
                            class="restrinctions-select-autocomplete"
                            :multiple="true"
                            :disabled="view.exportData.checkedFilial"
                            :options="view.exportData.filial"
                            :getOptionLabel="o => `${o.CDFILIAL} | ${o.NMFILIAL}`"
                            :clearable="false" 
                            v-model="view.exportData.selectedFilial"
                            @input="getServico"
                        ></v-select>
                        <div class="input-container">
                            <input 
                                class="allCheck"
                                type="checkbox"
                                id="scales"
                                name="scales"
                                :checked="view.exportData.checkedFilial"
                                @click="allFiliClicked" 
                            />
                            <span>{{$t('all')}}</span>
                        </div>
                    </div>
                    
                    <label for="export-service">{{$t('service')}}:</label>
                    <div class="select-container">
                        <v-select
                            class="restrinctions-select-autocomplete"
                            :multiple="true"
                            :disabled="view.exportData.checkedService == true"
                            :options="view.exportData.services"
                            :getOptionLabel="o => `${o.CDFILIAL} | ${o.CDSERVFILI} | ${o.NMSERVICO}`"
                            :clearable="false" 
                            v-model="view.exportData.selectedService"
                        ></v-select>
                        <div class="input-container">
                            <input 
                                class="allCheck"
                                type="checkbox"
                                id="scales"
                                name="scales"
                                :checked="view.exportData.checkedService"
                                @click="allServiceClicked" 
                            />
                            <span>{{$t('all')}}</span>
                        </div>
                        
                    </div>
                </div>
                <div v-show="modalStyle == 'VALIDITY'">
                    <label for="export-service">{{$t('validity')}}:</label>
                    <v-select
                        class="restrinctions-select-autocomplete"
                        :options="view.exportData.validity"
                        :getOptionLabel="o => `${o.DTVIGENCIA} | ${o.DESCRICAO}`"
                        :clearable="false" 
                        v-model="view.exportData.selectedValidity"
                    ></v-select>
                </div>
                
                <label for="export-typeExport">{{$t('export_type')}}:</label>
                <div class="mode-switch">
                    <div v-if="showAdd" @click="switchMode('ACRESCENTAR')" 
                        class="mode-switch-option"
                        :class="{active: view.exportData.mode === 'ACRESCENTAR'}"> 
                    {{$t('add')}} </div>
                    <div v-if="showOverlap" @click="switchMode('SOBREPOR')" 
                        class="mode-switch-option"
                        :class="{active: view.exportData.mode === 'SOBREPOR'}"> 
                    {{$t('overlap')}} </div>
                </div>

                <div v-show="modalStyle == 'GROUP'">
                    <label for="export-typeExport">{{$t('question_delete_dish')}} ?</label>
                    <div class="mode-switch">
                        <div @click="switchModeGroup('S')" 
                            class="mode-switch-option"
                            :class="{active: view.exportData.modeGroup === 'S'}"> 
                        {{$t('delete')}} </div>
                        <div @click="switchModeGroup('N')" 
                            class="mode-switch-option"
                            :class="{active: view.exportData.modeGroup === 'N'}"> 
                        {{$t('do_not_delete')}} </div>
                    </div>
                </div>
            </div>
            <div class='button-div'>
                <button 
                    class="button outline modal-button"
                    style="line-height: .9rem"
                    @click="hideModal"> <i class="fas fa-times"></i
                > 
                    {{$t('cancel')}} 
                </button> 
                <button 
                    class="button modal-button"
                    style="line-height: 1.1rem"
                    @click="saveExport"
                >
                    <span v-show="showLoad"> {{$t('save')}} </span> 
                    <img v-show="!showLoad" :src="view.exportData.loadGif" style="height: 33px; margin: auto;"/>
                </button>
            </div>
        </div>
        <modal
            name="message" 
			:height="'auto'" 
			:clickToClose="false"
        >
            <message-pop-up 
                :modal="this.modal"
                :title="view.message.title"
                :message="view.message.message"
                :nameModal="'message'"
            />
        </modal>
    </div>
</template>

<script>
import vSelect from "vue-select";
import RestrictionProvider from '@/application/providers/RestrictionsProvider';
import MessagePopUp from '@/components/src/MessagePopUp';
import { t } from 'i18next';

export default {
    name: 'ExportForm',
    props: {
        modal: {
            type: Object
        },
        name: {
            type: String
        },
        modalStyle: {
            type: String,
            default: 'UNITY'
        },
        validity: {
            type: Object
        },
        showLoad: {
            type: Boolean,
            default: true
        },
        showAdd: {
            type: Boolean,
            default: true
        },
        showOverlap: {
            type: Boolean,
            default: true
        },
        showMultiGroup: {
            type: Boolean,
            default: false
        }
    },
    components: {
        "v-select": vSelect,
        "message-pop-up": MessagePopUp
    },
    data() {
        return {
            view: {
                exportData:{
                    mode: this.showAdd ? 'ACRESCENTAR' : 'SOBREPOR',
                    modeGroup: 'N',
                    filial: [],
                    selectedFilial: null,
                    services: [],
                    selectedService: null,
                    validity: [],
                    selectedValidity: null,
                    groupPrat: [],
                    selectedGroupPrat: null,
                    checkedFilial: false,
                    checkedService: false,
                    checkedMultGroup: false,
                    loadGif: require("../../../static/loading_gif_export.gif")
                },
                message: {
                    title: '',
                    message: ''
                }
            }
        }
    },
    mounted() {
        this.resetObjectModal();
        if(this.modalStyle == 'UNITY' || this.modalStyle == 'GROUP') {
            this.getFiliaOper();
            this.getServico();
            if(this.modalStyle == 'GROUP') this.getGroupPrat();
        } else if(this.modalStyle == 'VALIDITY') {
            this.updateDataValidity();
        }
    },
    methods: {
        getGroupPrat: function() {
            if (this.showMultiGroup) {
                RestrictionProvider.getMultiGroupPrat().then((group) => {
                    this.view.exportData.groupPrat = group;
                });
            } else {
                RestrictionProvider.getGroupPrat().then((group) => {
                    this.view.exportData.groupPrat = group;
                });
            }
        },
        getFiliaOper: function() {
			RestrictionProvider.getFiliaOper().then((filial) => {
				this.view.exportData.filial = filial;
			});
		},
		getServico: function() {
			let listaFilial = this.view.exportData.checkedFilial ? 'T' : '_';
			if(listaFilial !== 'T' && this.view.exportData.selectedFilial !== null) {
				this.view.exportData.selectedFilial.forEach((filial) => { listaFilial += '_' + filial.CDFILIAL });
            }
            RestrictionProvider.getServico(listaFilial, this.modalStyle).then((services) => {
				this.view.exportData.services = services;
			});
        },
        updateDataValidity: function() {
			RestrictionProvider.updateDataValidity(this.validity.grid.selectedValidity.NRVIGENCIA, this.validity.tableSelect).then((validityData) => {
				this.view.exportData.validity = validityData;
			});
        },
        resetObjectModal: function() {
			this.view.exportData.selectedFilial = null;
			this.view.exportData.selectedService = null;
			this.view.exportData.selectedValidity = null;
			this.view.exportData.services = [];
		},
        hideModal: function() {
            this.resetObjectModal();
            this.modal.hide('export-form-modal');
        },
        allFiliClicked: function() {
			this.view.exportData.selectedFilial = null;
			this.view.exportData.checkedFilial = !this.view.exportData.checkedFilial;
			if(this.view.exportData.checkedFilial){
			  this.getServico();  
			}else{
                this.view.exportData.selectedService = null;
			    this.view.exportData.checkedService = false;
			    this.view.exportData.services = [];
			}
        },
        allServiceClicked: function() {
			this.view.exportData.selectedService = null;
			this.view.exportData.checkedService = !this.view.exportData.checkedService;
        },
        allMultiGroupClicked: function() {
            this.view.exportData.selectedGroupPrat = null;
			this.view.exportData.checkedMultGroup = !this.view.exportData.checkedMultGroup;
        },
        saveExport: function() {
            if(this.isValidField()) {
                this.$emit('saveExport', this.view);
            } else {
                this.showLoad = true;
            }
        },
        switchMode: function(newMode) {
          this.view.exportData.mode = newMode;
        },
        switchModeGroup: function(newModeGroup) {
            this.view.exportData.modeGroup = newModeGroup;
        },
        isValidField: function() {
            if(this.modalStyle == 'VALIDITY') {
                if(this.view.exportData.selectedValidity == null) {
                    this.showMessage(t('invalid_data'), t('validity_field_not_selected'));
                    return false;
                }
            } else {
                if(!this.view.exportData.checkedFilial && this.view.exportData.selectedFilial == null) {
                    this.showMessage(t('invalid_data'), t('unit_field_not_selected'));
                    return false;
                } else if(!this.view.exportData.checkedService && this.view.exportData.selectedService == null) {
                    this.showMessage(t('invalid_data'), t('service_field_not_selected'));
                    return false;
                }
                if(this.modalStyle == 'GROUP') {
                    if(this.view.exportData.groupPrat.length === 0) {
                        this.showMessage(t('invalid_data'), t('without_plate_group'));
                        return false;
                    }
                    if(this.showMultiGroup) {
                        if(!this.view.exportData.checkedMultGroup && this.view.exportData.selectedGroupPrat == null) {
                            this.showMessage(t('invalid_data'), t('unselected_dish_group_field'));
                            return false;
                        }
                    } else {
                        if(this.view.exportData.selectedGroupPrat == null) {
                            this.showMessage(t('invalid_data'), t('unselected_dish_group_field'));
                            return false;
                        }
                    }
                }
            }

            return true;
        },
        showMessage: function(title, message) {
            this.view.message.title = title;
            this.view.message.message = message;
            this.$forceUpdate();
            this.modal.show('message');
        }
    }
}
</script>

<style lang="less" scoped>

.modal-button{
	font-size: .9rem;
	padding: 6px 13px;
	&.disabled{
		background-color: gray;
    	pointer-events: none;
	}
}

    .validity-form-root {
        width: calc(100% - 30px);
		margin: 25px;
		margin-bottom: 30px;

        .title {
            margin-bottom: 5px;
			margin-left: 10px;
        }

        .export-container {
			display: inline-block;
			margin: 10px;
			text-align: left;
			font-size: .9rem;
			width: calc(100% - 45px);
        }
        
        .select-container {
            display: grid;
            grid-template-columns: 80% 20%;

            .input-container {
                margin: auto;

                input, span {
                    vertical-align: middle;
                    display: inline-block;
                }
            }
        }

        .mode-switch {
            margin-top: 10px;
            font-size: .9rem;
            border-radius: 5px;
            width: fit-content;
            color: #DC143D;
            border: 1px solid #DC143D;
            cursor: pointer;
            user-select: none;
            width: 100%;
            display: flex;

            .mode-switch-option{
                flex: 1;
                text-align: center;
                border-radius: 5px;
                padding: 7px;
                transition: .3s background-color;
                &:hover{
                    background-color: #fcdee4;
                }

                &.active{
                    background-color: #DC143D;
                    color: white;
                }
            }
        }

        .allCheck {
            position: relative;
            cursor: pointer;
            height: 20px;
            width: 20px;
        }
        
        .allCheck:before {
            content: "";
            display: block;
            position: absolute;
            width: 20px;
            height: 20px;
            top: 0;
            left: 0;
            background-color: white;
            border: 2px solid #dc143d;
            border-radius: 5px;
        }

        .allCheck:checked:before {
            content: "";
            display: block;
            position: absolute;
            margin: auto;
            width: 20px;
            height: 20px;
            top: 0;
            left: 0;
            background-color: #dc143d;
            border: 2px solid #dc143d;
            border-radius: 5px;
        }

        .allCheck:checked:after {
            content: "";
            display: block;
            width: 5px;
            height: 10px;
            border: solid white;
            border-width: 0 2px 2px 0;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            position: absolute;
            top: 4px;
            left: 9px;
        }

        .button{
            min-width: 100px;
            padding: 6px 15px;
            margin: auto 3px;

            &.ghost{
                background-color: white;
                box-shadow: none;
                color: #dc143d;
                border: 1px solid #dc143d;
                padding: 5px 14px;

                &:hover{
                    color: #212146;
                    border: 1px solid #212146;
                }
            }
        }
        .vs_dropdown-menu {
            height: 110px;
        }
    }
</style>